import { stringifyQueryString as query} from 'external/react'
import {get, post} from 'external/axios'

export class CartService {
	 
	async anonymous(id:string) {
		let url = '/cart/anonymous'
		if (id) url = `${url}?${query({id})}`
		return get(url)
	}

	async client(client:string, id:string) {
		let url = '/cart/client'
		if (client) url = `${url}?${query({client, id})}`
		return get(url)
	}
	async create(client:string) {
		return post('/cart/create', {client})
	}

	async saveCart(cart:string) {
		return post('/cart/save', cart)
	}

}

export const cartService = new CartService()